import { BasicTrackingEvent } from "../BasicTrackingEvent";
import { BasicModel } from "../../basic/model/BasicModel";

export type MeasurementResultsEventVars = {
    readonly playerId: number;
    readonly sessionId: string;
    readonly sessionTime: number;
    readonly date: number;
    readonly level: number;
    readonly measurementDuration: number;
    readonly deviceId: number;
    readonly storeId: number;
    readonly memoryUsage: number;
    readonly buildVersion: number;
    readonly connectionType: string;
};

export class MeasurementResultsEvent extends BasicTrackingEvent {
    public sessionId: string;
    public sessionTime: number;
    public date: number;
    public level: number;
    public measurementDuration: number;
    public deviceId: number;
    public storeId: number;
    public memoryUsage: number;
    public buildVersion: number;
    public connectionType: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        // return value has still to be typed as `any`, otherwise subclasses can't extend...
        const vars: MeasurementResultsEventVars = {
            date: this.date,
            level: this.level,
            playerId: BasicModel.userData ? BasicModel.userData.playerID : -1,
            sessionId: this.sessionId,
            sessionTime: this.sessionTime,
            measurementDuration: this.measurementDuration,
            deviceId: this.deviceId,
            storeId: this.storeId,
            connectionType: this.connectionType,
            memoryUsage: this.memoryUsage,
            buildVersion: this.buildVersion,
        };

        return vars;
    }
}
